import React, { useState, useEffect } from "react";
import { Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import ImageUploadProviderImage from "./ImageUploadProviderImage";

const UploadedCopy = ({ data, onChange }) => {
  const [formData, setFormData] = useState({
    profileImage: null,
    nationalIdCopy: null,
    drivingLicenseCopy: null,
    residenceProof: null,
    loanApplicationLetter: null,
    maritalStatusProof: null,
    paymentReceipt: null,
    incomeOrBankStatement: null, // 
  });

  useEffect(() => {
    if (data && JSON.stringify(data) !== JSON.stringify(formData)) {
      setFormData((prev) => ({ ...prev, ...data }));
    }
  }, [data]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (JSON.stringify(formData) !== JSON.stringify(data)) {
        onChange(formData);
      }
    }, 500);
    return () => clearTimeout(timeout);
  }, [formData]);  // ✅ removed data & onChange from deps to avoid loop

  const handleImageSelect = ({ selectedFile }) => {
    setFormData((prev) => ({ ...prev, profileImage: selectedFile }));
  };

  const validateFile = (file) => {
    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
    const isValidType = allowedTypes.includes(file.type);
    const isSmallEnough = file.size / 1024 / 1024 < 2; // ✅ increased to 2MB

    if (!isValidType) message.error(`${file.name} must be a PDF, JPG, or PNG file!`);
    if (!isSmallEnough) message.error(`${file.name} exceeds the 2MB size limit!`);

    return isValidType && isSmallEnough;
  };

  const handleFileChange = ({ file }, fieldName) => {
    if (file.status === "removed") {
      setFormData((prev) => ({ ...prev, [fieldName]: null }));
    } else if (validateFile(file)) {
      setFormData((prev) => ({ ...prev, [fieldName]: file }));
    }
  };

  const uploadProps = (fieldName) => ({
    customRequest: ({ onSuccess }) => onSuccess("ok"),
    beforeUpload: (file) => validateFile(file) || Upload.LIST_IGNORE,
    onChange: (info) => handleFileChange(info, fieldName),
    fileList: formData[fieldName] ? [formData[fieldName]] : [],
    accept: ".pdf,.jpg,.jpeg,.png", // ✅ restrict file picker
    maxCount: 1, // ✅ only one file per field
  });

  const uploadFields = [
    { name: "nationalIdCopy",        label: "Injiza copy y'irangamuntu",              required: true  },
    { name: "drivingLicenseCopy",     label: "Injiza copy ya perimi",                  required: true  },
    { name: "residenceProof",         label: "Injiza icyangombwa cy'aho utuye",         required: true  },
    { name: "loanApplicationLetter",  label: "Injiza ibaruwa isaba inguzanyo",          required: true  },
    { name: "maritalStatusProof",     label: "Icyemezo cy'uko uri ingaragu / washatse", required: true  },
    { name: "incomeOrBankStatement",  label: "Injiza inyandiko y'imari (Income / Bank Statement)", required: true },
  ];

  return (
    <div className="space-y-6">
      {/* Profile Image */}
      <div>
        <label className="block text-sm font-medium mb-2">
          Injiza ifoto yawe <span className="text-red-400">*</span>
        </label>
        <ImageUploadProviderImage
          uploadedImage={formData.profileImage}
          onImageSelect={handleImageSelect}
        />
      </div>

      {/* Document Uploads */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {uploadFields.map(({ name, label, required }) => {
          const isUploaded = !!formData[name];
          return (
            <div
              key={name}
              className={`p-3 rounded-lg border transition-colors duration-200 ${
                isUploaded
                  ? "border-green-500 bg-green-500/10"
                  : "border-gray-600 bg-gray-800/30"
              }`}
            >
              <label className="block text-sm font-medium mb-2">
                {label}
                {required && <span className="text-red-400 ml-1">*</span>}
                {isUploaded && (
                  <span className="ml-2 text-green-400 text-xs">✓ Byinjijwe</span>
                )}
              </label>
              <Upload {...uploadProps(name)}>
                <Button
                  icon={<UploadOutlined />}
                  className={isUploaded ? "border-green-500 text-green-400" : ""}
                >
                  {isUploaded ? "Hindura dosiye" : "Hitamo dosiye"}
                </Button>
              </Upload>
              <p className="text-xs text-gray-400 mt-1">PDF, JPG, PNG • Max 2MB</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UploadedCopy;